<template>
  <div :id="'wordcloud' + id"></div>
</template>

<script>
import $ from "jquery";
import d3 from "d3/d3.js";
import * as d3_layout_cloud from "d3-cloud";

d3.layout.cloud = d3_layout_cloud;

export default {
  name: "word_cloud_chart",
  props: {
    dataset: Object,
    id: {
      type: String,
      default() {
        return "w1";
      },
    },
    min: {
      type: Number,
      default() {
        return 10;
      },
    },
    max: {
      type: Number,
      default() {
        return 100;
      },
    },
  },
  data() {
    return {
      data: this.dataset,
    };
  },
  methods: {
    drawWordCloud: function (location, word_count) {
      let self = this;
      var svg_location = "#" + location;
      var width = parseInt($("#" + self.id).width());
      var height = 400;
      $(svg_location).empty();
      var fill = d3.scale.category20();
      var word_entries = d3.entries(word_count);
      var xScale = d3.scale
        .linear()
        .domain([
          0,
          d3.max(word_entries, function (d) {
            return d.value;
          }),
        ])
        .range([self.min, self.max]);

      d3.layout
        .cloud()
        .size([width, height])
        .timeInterval(3)
        .words(word_entries)
        .fontSize(function (d) {
          return xScale(+d.value);
        })
        .text(function (d) {
          return d.key;
        })
        .rotate(function () {
          return 0;
        })
        .font("Impact")
        .on("end", draw)
        .start();

      function draw(words) {
        d3.select(svg_location)
          .html("")
          .append("div")
          .attr("align", "center")
          .attr("id", "wordcloud-container")
          .append("svg")
          .attr("style", "width:100%;")
          .attr("height", height)
          .append("g")
          .attr("transform", "translate(" + [width >> 1, height >> 1] + ")")
          .selectAll("text")
          .data(words)
          .enter()
          .append("text")
          .style("font-size", function (d) {
            return xScale(d.value) + "px";
          })
          .style("font-family", "Times New Roman")
          .style("cursor", "pointer")
          .style("fill", function (d, i) {
            return fill(i);
          })
          .attr("text-anchor", "middle")
          .attr("transform", function (d) {
            return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
          })
          .text(function (d) {
            return d.key;
          })
          .on("click", function (d) {
            let params = self.$route.query;
            params.q = d.text;
            if (params.items) {
              delete params.items;
            }
            self.$router.push({ path: "/posts", query: params });
          });
        $(".loader").fadeOut(1000);
      }

      d3.layout.cloud().stop();
    },
  },
  created: function () {
    if (this.data != null) {
      this.drawWordCloud("wordcloud" + this.id, this.data);
    }
  },
};
</script>